// Funcionalidades temporalmente ocultas. Cambiar a true para reactivarlas.
export const MOSTRAR_RECORDATORIOS_VALORES = false;
